module.exports = __webpack_public_path__ + "img/Cu(OH)2.062520bc.png";